/**
 * useScenarioManagement — Scenario and sensitivity CRUD, rename handlers.
 * Phase 3B: removed reloadState dependency. Rename operations update local
 * state directly (no tree invalidation needed for name changes).
 */

import { useState, useCallback } from 'react';
import apiService from '../../../services/ApiService';

interface UseScenarioManagementParams {
    currentScenario: any;
    currentSensitivity: any;
}

export function useScenarioManagement({
    currentScenario,
    currentSensitivity,
}: UseScenarioManagementParams) {
    const [renamingScenario, setRenamingScenario] = useState(false);
    const [scenarioRenameValue, setScenarioRenameValue] = useState('');
    const [renamingSensitivity, setRenamingSensitivity] = useState(false);
    const [sensitivityRenameValue, setSensitivityRenameValue] = useState('');

    const handleRenameScenario = useCallback(() => {
        const name = scenarioRenameValue.trim();
        if (!name || name === currentScenario.name) {
            setRenamingScenario(false);
            return;
        }
        apiService.putModelScenario(currentScenario.id, name).then(async (response) => {
            if (response) {
                currentScenario.name = name;
                setRenamingScenario(false);
            }
        });
    }, [scenarioRenameValue, currentScenario]);

    const handleRenameSensitivity = useCallback(() => {
        if (currentSensitivity === 'null') return;
        const name = sensitivityRenameValue.trim();
        if (!name || name === currentSensitivity.name) {
            setRenamingSensitivity(false);
            return;
        }
        apiService.putSensitivity(currentSensitivity.id, name).then(async (response) => {
            if (response) {
                currentSensitivity.name = name;
                setRenamingSensitivity(false);
            }
        });
    }, [sensitivityRenameValue, currentSensitivity]);

    const startRenamingScenario = useCallback(() => {
        setScenarioRenameValue(currentScenario?.name ?? '');
        setRenamingScenario(true);
    }, [currentScenario]);

    const startRenamingSensitivity = useCallback(() => {
        if (currentSensitivity !== 'null') {
            setSensitivityRenameValue(currentSensitivity.name);
            setRenamingSensitivity(true);
        }
    }, [currentSensitivity]);

    return {
        renamingScenario,
        setRenamingScenario,
        scenarioRenameValue,
        setScenarioRenameValue,
        renamingSensitivity,
        setRenamingSensitivity,
        sensitivityRenameValue,
        setSensitivityRenameValue,
        handleRenameScenario,
        handleRenameSensitivity,
        startRenamingScenario,
        startRenamingSensitivity,
    };
}
